import { NAVIGATION, trackMixpanelAction, useMultipleTabsOpen } from '@reapit-sales/utilities'
import { Dialog, Button, ButtonGroup } from '@reapit/elements'
import { useState } from 'react'
import { useHandleLogout } from '@crm/hooks'
import { LAST_LOGOUT_TIMESTAMP_KEY } from '@crm/constants'
import { useLegacyIframesVisibilityContext } from '@reapit-sales/legacy-crm'

export const useLogoutHandler = () => {
  // This hook manages the logout process, including clearing cache, useridentity and logout from RC
  const handleLogout = useHandleLogout()
  // This hook checks if multiple tabs are open
  const isMultipleTabsOpen = useMultipleTabsOpen()
  // This hook provides legacyCRMIframePageName - includes the page name
  const { legacyCRMIframePageName } = useLegacyIframesVisibilityContext()
  // State to manage the dialog visibility
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const performLogout = () => {
    // Track the Mixpanel event for logging out
    trackMixpanelAction(NAVIGATION.ACTION.NAVIGATE_LOGOUT, {
      Screen: NAVIGATION.SCREEN_NAME.LOGOUT,
      FromRoute: legacyCRMIframePageName,
    })

    // Set the last `lastLogoutTimestamp` timestamp in localStorage
    localStorage.setItem(LAST_LOGOUT_TIMESTAMP_KEY, Date.now().toString())

    // Handle the logout action
    handleLogout()
  }

  // If multiple tabs are open, show a confirmation dialog before logging out
  // If only one tab is open, log out directly without confirmation
  // This is to prevent accidental logouts when multiple tabs are open
  // and to ensure a clean session
  const handleLogoutClick = () => {
    if (isMultipleTabsOpen) {
      setIsDialogOpen(true) // Show the dialog if the condition is true
    } else {
      performLogout() // Perform logout directly
    }
  }

  const renderLogoutDialog = () => (
    <Dialog isOpen={isDialogOpen} size="small" title="Confirm Logout" onClose={() => setIsDialogOpen(false)}>
      <Dialog.Header>Confirm Logout</Dialog.Header>
      <Dialog.Body>
        This action will log you out of all open browser tabs. Any unsaved edits will be lost. Continue?
      </Dialog.Body>
      <Dialog.Footer>
        <ButtonGroup>
          <Button size="medium" variant="secondary" onClick={() => setIsDialogOpen(false)}>
            Cancel
          </Button>
          <Button
            size="medium"
            variant="primary"
            onClick={() => {
              setIsDialogOpen(false) // Close the dialog
              performLogout() // Perform logout directly
            }}
          >
            Logout
          </Button>
        </ButtonGroup>
      </Dialog.Footer>
    </Dialog>
  )

  return { handleLogoutClick, renderLogoutDialog }
}
